import React from 'react'
import styles from './LoginPopover.module.css'
import Button from '../Button/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTimes,
} from '@fortawesome/free-solid-svg-icons'

class LoginPopover extends React.Component {
    state = {
        email: '',
        pword: '',
    }

    handleLogin = () => {
        this.props.login({
            email: this.state.email,
            password: this.state.pword,
        })
    }

    handleKeyPress = event => {
        if(event.key === 'Enter') {
            this.handleLogin()
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    render() {
        return (
            <div className={styles.fullScreen}>
                <div className={styles.modalWrap}>
                    <div className={styles.headerWrap}>
                        <div>Login</div>
                        <div onClick={() => this.props.closeLoginModal()}>
                            <FontAwesomeIcon
                                icon={faTimes}
                            />
                        </div>
                    </div>
                    <div className={styles.bodyWrap} data-cy="login-modal-bodyWrap" cy-login-modal>
                        <input
                            className={styles.inputField}
                            type="text"
                            name="email"
                            placeholder="Email address"
                            value={this.state.email}
                            onChange={this.handleChange}
                        />
                        <input
                            className={styles.inputField}
                            type="password"
                            name="pword"
                            placeholder="Password"
                            value={this.state.pword}
                            onChange={this.handleChange}
                            onKeyPress={this.handleKeyPress}
                        />
                        <div
                            className={styles.buttonRow}
                        >
                            <a href={`https://${process.env.NODE_ENV === 'production' ? 'app' : 'staging'}.beapplied.com/text-analysis-password-reset`} className={styles.linkText}>Forgotten your password?</a>
                            <div onClick={() => this.handleLogin({})}>
                                <Button pending={this.props.loginPending}>Login</Button>
                            </div>
                        </div>
                        { this.props.loginFailed ?
                            <div className={styles.loginError}>
                                Incorrect login, please try again
                            </div>
                            : null
                        }
                        {this.props.loginExpired ? (
                            <div className={styles.loginError}>
                                Your access has expired, please get in touch with us at <a href="mailto:questions@beapplied.com">questions@beapplied.com</a>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginPopover
